module.exports = __webpack_public_path__ + "img/Semper_Fi_Cycle@2x.6e011784.png";